export function formatSurcharge(surchargeRate: any) {
  if (typeof surchargeRate !== "number" || isNaN(surchargeRate)) {
    return "0";
  }

  const percentageValue = Math.round(surchargeRate * 10000) / 100;

  return `${percentageValue}`;
}
